module.exports = __webpack_public_path__ + "img/print-24px.1782c60e.svg";